import React from "react";
import '../../App.css'

export default function Donate(){
    return <h1 className="donate">DONATE</h1>;
    
}